module.exports = __webpack_public_path__ + "static/covid-6-01d4e1a40d2ec7008c8a742453f58e34.png";